import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import getSignalsCallLogs, {
	SignalsCallLog,
} from 'api/signals/getSignalsCallLogs'
import getFullDate from 'utils/getFullDate'

interface PropTypes {
	clientId: string
}

const SignalsCallLogsTable: React.FC<PropTypes> = ({ clientId }) => {
	const [records, setRecords] = useState<SignalsCallLog[]>([])
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		if (!clientId) return
		setLoading(true)
		getSignalsCallLogs(clientId)
			.then(data => setRecords(data || []))
			.catch(() => setRecords([]))
			.finally(() => setLoading(false))
	}, [clientId])

	const columns: ColumnsType<SignalsCallLog> = [
		{
			title: 'Number',
			dataIndex: 'number',
			key: 'number',
		},
		{
			title: 'Direction',
			dataIndex: 'direction',
			key: 'direction',
			render: (v: string) => (v === 'inbound' ? 'Inbound' : 'Outbound'),
		},
		{
			title: 'Type',
			dataIndex: 'type',
			key: 'type',
			render: (v: string) => (v === 'missed' ? 'Missed' : 'Answered'),
		},
		{
			title: 'Duration',
			dataIndex: 'duration',
			key: 'duration',
			render: (v: number) => (v > 0 ? `${v}s` : '-'),
		},
		{
			title: 'Date',
			dataIndex: 'timestampUtc',
			key: 'timestampUtc',
			render: (v: string) => (v ? getFullDate(v) : '-'),
		},
		{
			title: 'Agent',
			key: 'agent',
			render: (_, record) => {
				const a = record.agentId
				if (!a) return '-'
				const name = [a.firstName, a.lastName].filter(Boolean).join(' ')
				return name || a.email || '-'
			},
		},
	]

	return (
		<Table
			loading={loading}
			dataSource={records}
			columns={columns}
			rowKey='_id'
			pagination={{ pageSize: 20 }}
		/>
	)
}

export default SignalsCallLogsTable
